import { apiRequest } from "./client";

export type MailClient = "gmail" | "outlook_web" | "yandex";

export interface ExtensionHealthIssue {
  id: string;
  mail_client: MailClient;
  extension_version: string;
  failed_selectors: string[];
  dom_snapshot_anonymized: string | null;
  resolved_at: string | null;
  created_at: string;
}

export interface ExtensionHealthListResponse {
  items: ExtensionHealthIssue[];
  total_count: number;
}

export interface ExtensionHealthListQuery {
  page?: number;
  size?: number;
  mail_client?: MailClient;
  resolved?: boolean;
}

function buildQuery(query: ExtensionHealthListQuery): string {
  const params = new URLSearchParams();
  if (query.page !== undefined) params.set("page", String(query.page));
  if (query.size !== undefined) params.set("size", String(query.size));
  if (query.mail_client) params.set("mail_client", query.mail_client);
  if (query.resolved !== undefined)
    params.set("resolved", String(query.resolved));
  const s = params.toString();
  return s ? `?${s}` : "";
}

export const extensionHealthApi = {
  list: (query: ExtensionHealthListQuery = {}) =>
    apiRequest<ExtensionHealthListResponse>(
      `/extension/health-issues${buildQuery(query)}`,
    ),
  resolve: (id: string) =>
    apiRequest<ExtensionHealthIssue>(
      `/extension/health-issues/${id}/resolve`,
      { method: "POST" },
    ),
};
